/**
 * Enum for specifying the target attribute of a link, determining where the linked document will be opened.
 */
export var Target;
(function (Target) {
    Target["Self"] = "_self";
    Target["Parent"] = "_parent";
    Target["Top"] = "_top";
    Target["Blank"] = "_blank"; // Open the link in a new window or tab.
})(Target || (Target = {}));
//# sourceMappingURL=Target.js.map